import React, { useState } from "react";
import { Backdrop, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { theme } from "../../theme";
import { t } from "i18next";
import { IRole } from "@backend/model/role";
import { DatePicker } from "@mui/x-date-pickers";
import { ImageUploadField } from "../components/ImageUploadField";

interface IMissingFieldsQueryProps {
  missingFields: string[];
  onSave: (data: IRole) => void;
  loading?: boolean;
}

export const MissingFieldsQuery = (props: IMissingFieldsQueryProps) => {
  const { missingFields } = props;

  const [data, setData] = useState<IRole | any>({});

  return (
    <Box display={"flex"} flexDirection={"column"} padding={theme.spacing(2)}>
      <Backdrop sx={{ color: "#ffff", zIndex: 10 }} open={!!props.loading}>
        <CircularProgress sx={{ alignSelf: "center" }} />
      </Backdrop>
      <Typography variant="h4">{t("missingFieldsTitle")}</Typography>
      {missingFields?.map((field) => {
        if (field === "dateOfBirth") {
          return (
            <DatePicker
              label={t(field)}
              key={"dateField_"+field}
              sx={{ marginTop: theme.spacing(2) }}
              onChange={(d: any) =>
                setData(Object.assign({}, data, { [field]: d }))
              }
            />
          );
        } else if (field.includes("Image")) {
          return (
            <ImageUploadField
              edit
              key={"imageField_"+field}
              label={t(field)}
              content={data[field] || ""}
              onValueChanged={(d: any) =>
                setData(Object.assign({}, data, { [field]: d }))
              }
            />
          );
        } else {
          return (
            <TextField
              label={t(field)}
              key={"textField_"+field}
              content={data[field] ||""}
              style={{ marginTop: theme.spacing(2) }}
              onChange={(e) =>
                setData(Object.assign({}, data, { [field]: e.target.value }))
              }
            />
          );
        }
      })}
      <Button
        style={{ marginTop: theme.spacing(2) }}
        variant="contained"
        onClick={() => props.onSave(data)}
      >
        {t("save")}
      </Button>
    </Box>
  );
};
